import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// move to .ENV
const firebaseConfig = {
    apiKey: "AIzaSyDmyXrcKfp6jjNs5Y3-EA2THeP72uIJypQ",
    authDomain: "threeputt-api.firebaseapp.com",
    projectId: "threeputt-api",
    appId: "1:346170434973:web:4a2969e1d55541d3f93b74",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();